import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedCampaignGoalSelectionStepWithI18n } from './delayed-campaign-goal-selection-step';

export const CampaignGoalSelectionStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.CAMPAIGN_GOAL_SELECTION,
  view: DelayedCampaignGoalSelectionStepWithI18n,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
